export default __webpack_public_path__ + "static/media/ddsu5168-3.60432f33.png";